<template>

<app-content :loading="is.loading">

	<app-content-head title="Settings" :readonly="$authorised('mem/checkins/access', 'read')">

		<app-content-head-actions-item :disabled="!isDirty" icon="undo" text="Undo" v-on:click="onUndoClick" />
		<app-content-head-actions-item :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" text="Save" v-on:click="onSaveClick" />

	</app-content-head>

	<app-content-body>

		<app-content-box title="General" icon="settings">

            <app-input-text :toggle="model.checkins.autoclose.enabled" v-on:toggle="model.checkins.autoclose.enabled = !model.checkins.autoclose.enabled" label="Active" v-model="model.checkins.autoclose.duration" :validation="$v.model.checkins.autoclose.duration" placeholder="Enter duration" suffix="seconds" notes="Automatically close checkin screen after specified seconds once any alerts have been dismissed." />

		</app-content-box>

		<app-content-box title="Checkin Sounds" icon="audio">

            <app-input-file :toggle="model.checkins.sound.active.enabled" v-on:toggle="model.checkins.sound.active.enabled = !model.checkins.sound.active.enabled" label="Active" v-model="model.checkins.sound.active.file" :validation="$v.model.checkins.sound.active.file" placeholder="Enter text" accept="mp3" notes="Play sound when an active subscription is scanned." />

            <app-input-file :toggle="model.checkins.sound.expiring.enabled" v-on:toggle="model.checkins.sound.expiring.enabled = !model.checkins.sound.expiring.enabled" label="Expiring" v-model="model.checkins.sound.expiring.file" :validation="$v.model.checkins.sound.expiring.file" placeholder="Enter text" accept="mp3" notes="Play sound when an expiring subscription is scanned." />

            <app-input-file :toggle="model.checkins.sound.cancelled.enabled" v-on:toggle="model.checkins.sound.cancelled.enabled = !model.checkins.sound.cancelled.enabled" label="Cancelled" v-model="model.checkins.sound.cancelled.file" :validation="$v.model.checkins.sound.cancelled.file" placeholder="Enter text" accept="mp3" notes="Play sound when a cancelled subscription is scanned." />

            <app-input-file :toggle="model.checkins.sound.failed.enabled" v-on:toggle="model.checkins.sound.failed.enabled = !model.checkins.sound.failed.enabled" label="Failed" v-model="model.checkins.sound.failed.file" :validation="$v.model.checkins.sound.failed.file" placeholder="Enter text" accept="mp3" notes="Play a sound when scan fails to match a subscription of any kind." />

		</app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			readonly: this.$authorised('mem/checkins/access', 'read'),
			settings: true,
			model: {
				checkins: {
                    autoclose: {
                        enabled: false,
                        duration: 0
                    },
                    sound: {
                        active: {
                            enabled: false,
                            file: ''
                        },
                        expiring: {
                            enabled: false,
                            file: ''
                        },
                        cancelled: {
                            enabled: false,
                            file: ''
                        },
                        failed: {
                            enabled: false,
                            file: ''
                        }
                    }
                }
			}
		}

	},

	validations: {
		model: {
			checkins: {
                autoclose: {},
                sound: {
                    active: {},
                    expiring: {},
                    cancelled: {},
                    failed: {}
                }
			}
		}
	}

}

</script>

<style scoped>

</style>